module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mySheet),
      expression: "mySheet"
    }],
    staticClass: "display-flex full-width timer-container",
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_c('div', [_c('v-icon', {
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("timer")])], 1), _vm._v(" "), _c('div', {
    staticClass: "timer-text"
  }, [_vm._v("\n            Today: " + _vm._s(_vm.durationToday) + ". Total " + _vm._s(_vm.durationTotal) + "\n            "), (_vm.paused) ? _c('span', [_vm._v("(Paused)")]) : _vm._e()]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "grey"
    }
  }, [_vm._v("keyboard_arrow_down")])], 1)], 1), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "expanded-section"
  }, [_c('table', [_vm._l((_vm.sheets), function(sheet) {
    return _c('tr', {
      key: sheet._id
    }, [_c('td', [_vm._v("\n                " + _vm._s(sheet.userName) + "\n            ")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.duration(sheet.total)) + "\n            ")])])
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                 Total Time\n            ")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.duration(_vm.allUserTotal)) + "\n            ")])])], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c613c48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/TimeTracker.vue
// module id = 2566
// module chunks = 1